import { initUserpilot } from './initialize'

void initUserpilot()
